$(document).ready(function() {

    $(document).on('mousemove', function(e) {
        $('.custom-cursor').css({
            left: e.clientX,
            top: e.clientY
        });
    });

    $('.thumbnail').mouseenter(function() {
        $('.custom-cursor').addClass('activeproject');
    });

    $('.thumbnail').mouseleave(function() {
        $('.custom-cursor').removeClass('activeproject');
    });

    $('body a').mouseenter(function() {
        $('.custom-cursor').addClass('activemenu');
    });

    $('body a').mouseleave(function() {
        $('.custom-cursor').removeClass('activemenu');
    });

});

$("a[href='#top']").click(function() {
    $("html, body").animate({ scrollTop: 0 }, "slow");
    return false;
});
